const STATE = {
  idle: 'idle',
  running: 'running',
  paused: 'paused',
  resumed: 'resumed',
}

class IntervalTimer {
  constructor(callback, interval) {
    this.interval = interval
    this.callback = callback

    this.state = STATE.idle
    this.pausedTime = 0
    this.remainingTime = 0
  }

  proxyCallback() {
    this.lastFireTime = new Date()

    this.callback()
  }

  start() {
    this.timerId = setInterval(() => this.proxyCallback(), this.interval)

    this.lastFireTime = new Date()

    this.state = STATE.running
  }

  pause() {
    if (this.state !== STATE.running && this.state !== STATE.resumed) return

    this.remainingTime =
      this.interval - (new Date() - this.lastFireTime) + this.pausedTime
    this.lastPauseTime = new Date()

    clearInterval(this.timerId)
    clearTimeout(this.resumeId)

    this.state = STATE.paused
  }

  resume() {
    if (this.state !== STATE.paused) return

    this.pausedTime += new Date() - this.lastPauseTime

    this.state = STATE.resumed

    this.resumeId = setTimeout(() => this.timeoutCallback(), this.remainingTime)
  }

  timeoutCallback() {
    if (this.state !== STATE.resumed) return

    this.pausedTime = 0

    this.proxyCallback()
    this.start()
  }

  stop() {
    if (this.state === STATE.idle) return

    clearInterval(this.timerId)
    clearTimeout(this.resumeId)

    this.state = STATE.idle
  }

  setInterval(newInterval) {
    if (this.state === STATE.running) {
      this.pause()

      this.interval = newInterval

      this.resume()
    } else {
      this.interval = newInterval
    }
  }
}

export default IntervalTimer
